export const getCoordinates = async geolocation => {
  if (!geolocation) return { longitude: null, latitude: null };

  let position = null;
  try {
    position = await new Promise((resolve, reject) => {
      geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
      });
    });
  } catch (e) {}

  const coordinates =
    position && position.coords
      ? {
          longitude: position.coords.longitude,
          latitude: position.coords.latitude,
        }
      : { longitude: null, latitude: null };

  return coordinates;
};
